<template>
<div class="appealDlogBox">
    <el-form ref="appealFromDom" :model="appealFrom" :rules="passRules" label-width="80px">
        <el-form-item label="申诉理由" prop="cause">
          <el-input type="textarea" :rows="3" placeholder="请输入理由" v-model="appealFrom.cause" clearable></el-input>
        </el-form-item>
        <el-form-item label="上传文件">
          <div style="display:flex">
            <el-upload
              :headers="headers"
              action="/resource/File/UploadFile"
              :on-remove="activityFileHandleRemove"
              :on-success="activitysuccess"
              multiple
              v-model="appealFrom.fileUrl"
              :accept="accept"
              :limit="1"
              :show-file-list="false"
            >
              <el-button type="primary">上传</el-button>
            </el-upload>
            <el-button
              style="margin-left: 10px;"
              v-if="appealFrom.fileUrl"
              @click="activityFileHandleLook"
            >查看</el-button>
          </div>
        </el-form-item>
        
        <div v-if="dataState">
          <span>审核状态：</span>
          <span v-if="appealFrom.passStatus==1" style="color: green;">通过</span>
          <span v-if="appealFrom.passStatus==0">审核中</span>
          <span v-if="appealFrom.passStatus==-1" style="color: red;">不通过</span>
        </div>
        <div style="margin-top: 10px;" v-if="dataState">
          <span>通过理由：</span>
          <span v-if="appealFrom.passReason">{{appealFrom.passReason}}</span>
          <span v-else>无</span>
        </div>
    </el-form>
</div>
</template>

<script>
import {
    addAlarmFree
} from '@/api/train/index';
export default {
    props:['trainId','courseId','dataState','kqDataObj'],
    data(){
        return {
            appealFrom:{
                cause: '',
                fileUrl: '',
                trainId: this.trainId > 0 ? this.trainId : 0,
                courseId: this.courseId > 0 ? this.courseId : 0,
                userId: Number(this.$store.state.User.ids),
            },
            accept: '.ppt,.pdf,.pptx,.doc,.docx,.xls,.xlsx',
            passRules: {
                cause: [{ required: true, message: '请输入申请理由', trigger: 'blur' }],
            },
        }
    },
    computed: {
        headers() {
            return {
                Authorization: 'Bearer ' + this.$store.getters.tokens,
            };
        },
    },
    created(){
        if(this.dataState){
            this.appealFrom = this.kqDataObj;
        }
    },
    methods:{
        //移除文件
        activityFileHandleRemove(file, fileList) {
            this.appealFrom.fileUrl = '';
            this.$message.success('移除成功');
        },
        //上传成功
        activitysuccess(response, file, fileList) {
            this.appealFrom.fileUrl = response.result;
            this.$message.success('上传成功');
            this.$forceUpdate();
        },
        //查看文件
        activityFileHandleLook() {
            if (this.appealFrom.fileUrl == '') {
                this.$notify({
                    title: '失败',
                    message: '没有文件可查看',
                    type: 'warning',
                });
            } else {
                //下载文件
                window.open(this.appealFrom.fileUrl);
            }
        },
        //提交申诉
        submitFrom(){
            this.$refs['appealFromDom'].validate((valid) => {
                if (valid) {
                    addAlarmFree(this.appealFrom).then(res=>{
                        if(res.code == 200){
                            this.$message.success('提交成功');
                            this.$emit('close');
                        }
                    })
                }
            });
            
        },
    }
}
</script>

<style lang="less" scoped>

</style>